<template>
  <div class="home">
    
    <HelloWorld msg="Water Plan  "/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/CoursesWorld.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  }
}
</script>
